import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import moment from "moment-timezone";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {useGetDayQuery} from "../../slices/apiSlice";
import {setDay} from "../../slices/sessionSlice";

const selectDefaultDay = (days) => {
    if (!days || days.length===0) return undefined

    const ret =  days.findIndex( (day) =>
            moment().isBetween(moment(day.d),moment(day.d).add(1,'day'))
        )


    return ret !== -1 ? ret : 0
}

const DaySelector = ({}) => {
    const dispatch = useDispatch()
    const days = useSelector(state => state.session.days)

    const [dayIndex,setDayIndex] = React.useState(selectDefaultDay(days))

    const {data: day, isSuccess: isDaySuccess} = useGetDayQuery(days ? days[dayIndex]?.i : undefined,{skip:dayIndex===undefined})

    let j=0
    let k=0

    const handleSelectDay = (idx) => {
        setDayIndex(idx)
    }

    useEffect(() => {
        if (day) {
            dispatch(setDay(day))
        }
    }, [day]);


    return (
        <>
        {days &&
            <Box sx={{display: 'flex', alignItems: 'center', flexGrow: 1, justifyContent: 'flex-end'}}>
                {days.map((day, i) => {
                    const isToday = moment().isBetween(moment(day.d), moment(day.d).add(1, 'day'))

                    const isSelected = dayIndex === i
                    const styling = isSelected ? {borderBottom: 'solid 1px #ffffff'} : {}

                    if (isToday) {
                        styling['background'] = '#335e7b'
                    }

                    return (
                        <MenuItem key={day.i} sx={styling} onClick={() => {
                            handleSelectDay(i)
                        }} disableGutters>
                            <Typography variant={'body2'} textAlign="center" px={'.7em'}>
                                {(day.y === 2 ? 'Practice ' + (++k) : 'Day ' + (++j)) + (day.y === 3 ? ' (C)' : day.y === 4 ? ' (R)' : '')}
                            </Typography>
                        </MenuItem>
                    )
                })}
            </Box>
        }
        </>
    );
};

export default DaySelector;